/**
 * @generated SignedSource<<d2577eb2026b619b2dad127baed9f412>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlockRealmData$data = {
  readonly blocks: ReadonlyArray<{
    readonly editMode: boolean | null | undefined;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"BlocksBlockData">;
  }>;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"BlocksRealmData" | "EditButtonsRealmData" | "EditModeRealmData">;
  readonly " $fragmentType": "BlockRealmData";
};
export type BlockRealmData$key = {
  readonly " $data"?: BlockRealmData$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlockRealmData">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlockRealmData",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BlocksRealmData"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditButtonsRealmData"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditModeRealmData"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "blocks",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BlocksBlockData"
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "editMode",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Realm",
  "abstractKey": null
};
})();

(node as any).hash = "5260559326539fcc2b551167a096cf6e";

export default node;
